import { render, staticRenderFns } from "./VAbsence.vue?vue&type=template&id=49223d4e&"
import script from "./VAbsence.vue?vue&type=script&lang=js&"
export * from "./VAbsence.vue?vue&type=script&lang=js&"
import style0 from "./VAbsence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports